// extracted by mini-css-extract-plugin
export default {"validationErrors":"User_validationErrors__6fffR","alertBox":"User_alertBox__qd8-+","dangerAlert":"User_dangerAlert__WLJ6Q","warningAlert":"User_warningAlert__ac3b-"};